export function truncateText(text: string, limit = 25, completeWords = false, ellipsis = '...'): string {
  if (completeWords) {
    limit = text.substr(0, limit).lastIndexOf(' ');
  }
  return text.length > limit ? text.substr(0, limit) + ellipsis : text;
}
